module.exports = __webpack_public_path__ + "static/img/A61802_4.063a41d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61802_4.png
// module id = HAmA
// module chunks = 1